import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { useMatches } from 'react-router';
import { z } from 'zod';

// A route supplies a component here, so the handle check confirms the slot holds something callable.
const schema = z.object({
  DisplayPreferences: z.custom<(props: Record<string, unknown>) => ReactNode>((val) => typeof val === 'function'),
});

export function DisplayPreferences() {
  const matches = useMatches();

  const RouteDisplayPreferences = useMemo(() => {
    const reversedMatches = [...matches].reverse();

    for (const match of reversedMatches) {
      const parse = schema.safeParse(match.handle);
      if (parse.success) {
        return parse.data.DisplayPreferences;
      }
    }
    return undefined;
  }, [matches]);

  if (RouteDisplayPreferences === undefined) {
    return null;
  }

  return (
    <div>
      <RouteDisplayPreferences />
    </div>
  );
}
